import request from '@/utilsCloud/request'
import port from './port'
/**
 * 获取企业信息（entpId）
 * @param {*} entpWebsite 企业域名
 * @response {*} {entpId 企业ID...}
 */
export function getEnterpriseWebsite(query) {
    return request({
        url: port.biz+'/enterprise/getEnterpriseWebsite',
        headers: {
            isToken: false //不需要带token
        },
        method: 'get',
        params: query
    })
}

/**
 * 获取企业详情
 * @param {*} entpId ID
 * @response {*} {empName 企业名, webIco 浏览器图标...}
 */
 export function enterpriseInformation(query) {
    return request({
        url: port.biz+'/enterprise/enterpriseInformation',
        headers: {
            isToken: false
        },
        method: 'get',
        params: query
    })
}


// WEBPACK FOOTER //
// ./src/apiCloud/enterprise.js